import React from "react";

export const SmallDivider = ({ style }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        paddingTop: "1rem",
        paddingBottom: "1rem",
        ...style
      }}
    >
      <div className="small-x-divider" aria-hidden="true">
        <svg viewBox="0 0 90.8 7.9">
          <g fill="#002b45">
            <g>
              <rect x="54.4" y="3.1" width="36" height="1" />
              <rect x="0.4" y="3.1" width="36" height="1" />
            </g>
            <g>
              <rect
                x="44.9"
                y="-0.6"
                transform="matrix(0.7071 0.7071 -0.7071 0.7071 16.071 -30.9373)"
                width="1"
                height="9"
              />
              <rect
                x="40.9"
                y="3.4"
                transform="matrix(0.7071 0.7071 -0.7071 0.7071 16.0696 -30.9361)"
                width="9"
                height="1"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};

export const FullWidthDivider = ({ style }) => {
  return (
    <div className="full-width-separator" style={{ marginTop: "15px", ...style }}>
      <div className="triple-x-divider">
        <div className="horizontal-line flexible" style={{ backgroundColor: "rgb(0, 42, 70)" }} />
        <svg width="34px" height="10px" preserveAspectRatio="none">
          <g transform="translate(0, 2)">
            <g strokeWidth="1" stroke="#002A46">
              <line x1="5" y1="0" x2="13.5" y2="0" transform="rotate(45, 5, 0)" />
              <line x1="11" y1="0" x2="19.5" y2="0" transform="rotate(135, 11, 0)" />
            </g>
            <g strokeWidth="1" stroke="#002A46" transform="translate(9)">
              <line x1="5" y1="0" x2="13.5" y2="0" transform="rotate(45, 5, 0)" />
              <line x1="11" y1="0" x2="19.5" y2="0" transform="rotate(135, 11, 0)" />
            </g>
            <g strokeWidth="1" stroke="#002A46" transform="translate(18)">
              <line x1="5" y1="0" x2="13.5" y2="0" transform="rotate(45, 5, 0)" />
              <line x1="11" y1="0" x2="19.5" y2="0" transform="rotate(135, 11, 0)" />
            </g>
          </g>
        </svg>
        <div className="horizontal-line flexible" style={{ backgroundColor: "rgb(0, 42, 70)" }} />
      </div>
    </div>
  );
};
